import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { Scrollbars } from "react-custom-scrollbars";
// Google Maps api for react
import { GoogleMap, LoadScript } from "@react-google-maps/api";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// material-ui components
// styles
import "./mapPages.css";
import { PageContainer } from "./styles";
import LateralCard from "components/LateralCard/LateralCard";
import InputAdornment from "@material-ui/core/InputAdornment";
import DynamicInput from "components/DynamicInput/DynamicInput";
import Button from "components/CustomButtons/Button.js";
import HistoryMapRow from "components/HistoryMapRow/HistoryMapRow";
import Search from "@material-ui/icons/Search";
import ArrowBack from "@material-ui/icons/ArrowBack";
import { ListStyled, OverTable, styles } from "./styles";

// Hooks
import { useColorTheme } from "hooks/useColorTheme";
import HistoryMapMarkers from "components/HistoryMapMarkers/HistoryMapMarkers";
import { useHistory } from "react-router";
// actions creators

const renderView = ({ style, ...props }) => {
  return <ListStyled {...props} style={{ ...style }} />;
};

const useStyles = makeStyles(styles);

const ordersSelectedFilteredSelector = createSelector(
  (state) => state.ordersHistory.ordersSelected,
  (_, search) => search,
  (ordersSelected, search) =>
    ordersSelected.filter((order) => order.customer.includes(search))
);

export default function MapPage(props) {
  const classes = useStyles();
  let history = useHistory();
  // global states
  const colorBg = useSelector((state) => state.config.colorBg);

  // Custom hooks
  const { color, colorRGB } = useColorTheme(colorBg);

  // end
  const [currentPosition, setCurrentPosition] = useState({});
  const [search, setSearch] = useState("");
  const ordersSelected = useSelector((state) =>
    ordersSelectedFilteredSelector(state, search)
  );

  const success = (position) => {
    const currentPosition = {
      lat: parseFloat(position.coords.latitude.toFixed(4)),
      lng: parseFloat(position.coords.longitude.toFixed(4)),
    };
    setCurrentPosition(currentPosition);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleGoBack = (page) => {
    history.goBack();
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(success);
  }, []);

  return (
    <PageContainer>
      <LoadScript googleMapsApiKey={process.env.REACT_APP_MAPS_API_KEY}>
        <GoogleMap
          mapContainerClassName="mapPage_map"
          options={{
            fullscreenControl: false,
          }}
          zoom={13}
          fullscreenControl={false}
          center={currentPosition}
        >
          <HistoryMapMarkers orders={ordersSelected} color={colorRGB} />
        </GoogleMap>
      </LoadScript>
      <LateralCard
        isOpen={true}
        isLoading={false}
        colorRGB={colorRGB}
      >
        <OverTable>
          <DynamicInput
            id="material"
            color={color}
            formControlProps={{
              fullWidth: true,
              className: classes.noPaddingTop,
            }}
            inputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
              onChange: handleSearch,
              color: "secondary",
              placeholder: "Buscar...",
            }}
          />
        </OverTable>
        <Scrollbars className="scrollbar" autoHide renderView={renderView}>
          {ordersSelected.map((note) => (
            <HistoryMapRow
              key={note.id}
              item={note}
              isOpen={note.isOpen}
              colorRGB={colorRGB}
            />
          ))}
        </Scrollbars>
      </LateralCard>
      <Button
        onClick={handleGoBack}
        justIcon
        round
        color="danger"
        className={classes.backButton}
      >
        <ArrowBack />
      </Button>
    </PageContainer>
  );
}
